"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _gameLevels = require("@/api/game-levels");
var _app = require("@/store/modules/app");
var _tagsView = require("@/store/modules/tags-view");
var _router = _interopRequireDefault(require("@/router"));
var _vuexModuleDecorators = require("vuex-module-decorators");
var _index = _interopRequireDefault(require("@/components/FileUpload/index.vue"));
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.image = [];
    this.formData = Object.assign({}, _gameLevels.defaultGameLevelData);
    this.loading = false;
    this.rules = {
      name: [{
        required: true,
        message: 'Please enter name',
        trigger: 'blur'
      }],
      title: [{
        required: true,
        message: 'Please enter title',
        trigger: 'blur'
      }],
      description: [{
        required: true,
        message: 'Please enter description',
        trigger: 'blur'
      }],
      startColour: [{
        required: true,
        message: 'Please enter start colour',
        trigger: 'blur'
      }],
      endColour: [{
        required: true,
        message: 'Please enter end colour',
        trigger: 'blur'
      }],
      startValue: [{
        required: true,
        message: 'Please enter start value',
        trigger: 'blur'
      }],
      endValue: [{
        required: true,
        message: 'Please enter end value',
        trigger: 'blur'
      }]
    };
  }
  get lang() {
    return _app.AppModule.language;
  }
  created() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, _gameLevels.defaultGameLevelData);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await (0, _gameLevels.getGameLevelById)(id);
      this.formData = data;
      if (this.formData.image) {
        this.image = [{
          name: this.formData.name,
          url: this.formData.image
        }];
      }
      const title = 'Edit Game Level';
      this.setTagsViewTitle(title);
      this.setPageTitle(title);
    } catch (error) {
      this.$message.error(error.message || error);
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title} - ${this.formData.id}`;
      _tagsView.TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  fileUploaded(file) {
    this.formData.image = file.response;
  }
  async saveForm() {
    try {
      this.loading = true;
      if (this.isEdit) {
        await (0, _gameLevels.updateGameLevel)(this.formData.id, this.formData);
      } else {
        await (0, _gameLevels.createGameLevel)(this.formData);
      }
      this.$notify({
        title: 'Success',
        message: 'Game Level saved successfully',
        type: 'success',
        duration: 2000
      });
      _router.default.push('/game-levels/list');
    } catch (error) {
      this.loading = false;
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], default_1.prototype, "saveForm", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'GameLevelDetail',
  components: {
    FileUpload: _index.default
  }
})], default_1);
var _default = exports.default = default_1;